
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-creative-authorities",
      function () {
        return require("private-next-pages/for-creative-authorities.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-creative-authorities"])
      });
    }
  